<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini" ref="form" @submit.native.prevent="onSubmit">
            <el-form-item label="运营人员：" class="query-form-item">
                <el-select v-model="query.operation_id" placeholder="请选择" clearable filterable style="width: 150px">
                    <el-option
                        v-for="item in managerAnalysisList"
                        :key="item.id"
                        :label="item.full_name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序字段：" class="query-form-item">
                <el-select v-model="query.order_field" placeholder="排序字段" clearable style="width: 150px">
                    <el-option label="最新操作时间" value="last_update_time"></el-option>
                    <el-option label="状态变更时间" value="activity_create_time"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序类型：" class="query-form-item">
                <el-select v-model="query.order_type" placeholder="排序类型" clearable style="width: 120px">
                    <el-option label="升序" value="asc"></el-option>
                    <el-option label="降序" value="desc"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit" native-type="submit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            stripe
            border
            style="width: 100%"
            size="mini">
            <el-table-column label="项目" width="120" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.project_name || '-' }}</span>
                </template>
            </el-table-column>

            <el-table-column label="内容" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        <div :class="['content-text', { 'content-urgent': isContentUrgent(scope.row) }]">
                            {{ scope.row.content || '-' }}
                        </div>
                    </div>
                </template>
            </el-table-column>

      
            <el-table-column label="原状态" width="100" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.old_task_flowstatus || '-' }}</span>
                </template>
            </el-table-column>

            <el-table-column label="新状态" width="130" align="center">
                <template slot-scope="scope">
                    <span> {{  scope.row.new_task_flowstatus || '-' }}</span>
                </template>
            </el-table-column>

            <el-table-column label="状态变更时间" width="170" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.activity_create_time || '-' }}</span>
                </template>
            </el-table-column>

            <el-table-column label="最新操作时间" width="170" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.last_update_time || '-' }}</span>
                </template>
            </el-table-column>

            <el-table-column label="最新操作备注" min-width="180" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.last_comment || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="库存情况" min-width="180" align="center">
                <template slot-scope="scope">
                    <div class="inventory-wrap">
                        <div class="inventory-table">
                            <div class="inventory-head">
                                <span>Asin</span>
                                <span>可售</span>
                                <span>在途</span>
                            </div>
                            <div class="inventory-total-row">
                                <span>合计</span>
                                <span>{{ getInventoryTotal(scope.row.inventory, 'fba_sale_quantity') }}</span>
                                <span>{{ getInventoryTotal(scope.row.inventory, 'fba_transit_quantity') }}</span>
                            </div>
                            <div
                                v-for="(item, idx) in scope.row.inventory"
                                :key="idx"
                                class="inventory-row">
                                <span>{{ item.asin || '-' }}</span>
                                <span>{{ item.fba_sale_quantity || '-' }}</span>
                                <span>{{ item.fba_transit_quantity || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="total"
            background
            :current-page="query.page"
            style="margin-top: 10px; float: right;"
            layout="total, sizes, prev, pager, next">
        </el-pagination>
    </div>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'

    export default {
        data() {
            return {
                tableHeight: null,
                managerAnalysisList: [],
                query: {
                    operation_id: '',
                    order_field: 'last_update_time',
                    order_type: 'asc',
                    page: 1,
                    limit: 20
                },
                list: [],
                total: 0,
                loading: true
            }
        },
        methods: {
            getInventoryTotal(inventory, field) {
                if (!inventory || inventory.length === 0) return '-'
                const total = inventory.reduce((sum, item) => {
                    const val = parseFloat(item[field])
                    return sum + (isNaN(val) ? 0 : val)
                }, 0)
                return total || '-'
            },
            isContentUrgent(row) {
                const now = new Date()
                if (!row.last_update_time) {
                    if (row.activity_create_time) {
                        const diff = (now - new Date(row.activity_create_time)) / (1000 * 60 * 60 * 24)
                        return diff > 5
                    }
                    return false
                } else {
                    const diff = (now - new Date(row.last_update_time)) / (1000 * 60 * 60 * 24)
                    return diff > 21
                }
            },
            getManagerAnalysisList() {
                api.manager_index_get_operator_list().then(res => {
                    if (res.code === 0) {
                        this.managerAnalysisList = res.data || []
                        if (this.managerAnalysisList.length > 0) {
                            this.query.operation_id = this.managerAnalysisList[0].id
                            this.getList()
                        } else {
                            this.query.operation_id = ''
                        }
                    }
                }).catch(() => {})
            },
            handleVerify(row) {
                this.$message.info('核对功能开发中，ID: ' + row.id)
            },
            onReset() {
                this.query.operation_id = this.managerAnalysisList.length > 0 ? this.managerAnalysisList[0].id : ''
                this.query.order_field = 'last_update_time'
                this.query.order_type = 'asc'
                this.query.page = 1
                this.query.limit = 20
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.query.page = 1
                this.getList()
            },
            calcTableHeight() {
                const formH = this.$refs.form && this.$refs.form.$el ? this.$refs.form.$el.offsetHeight : 0
                this.tableHeight = window.innerHeight - 145 - formH
            },
            getList() {
                this.loading = true
                const tempQuery = JSON.parse(JSON.stringify(this.query))
                if (!tempQuery.operation_id) delete tempQuery.operation_id
                if (!tempQuery.order_field) delete tempQuery.order_field
                if (!tempQuery.order_type) delete tempQuery.order_type
                api.admin_teambition_need_verify_manager_lists(tempQuery)
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.list = res.data.list || []
                            this.total = res.data.total || 0
                        } else {
                            this.$message.error(res.message)
                            this.list = []
                            this.total = 0
                        }
                    })
                    .catch(() => {
                        this.loading = false
                        this.list = []
                        this.total = 0
                    })
            }
        },
        mounted() {
            this.$nextTick(() => this.calcTableHeight())
            const that = this
            window.onresize = () => that.calcTableHeight()
        },
        created() {
            this.getManagerAnalysisList()
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    .content-total {
        font-size: 12px;
        color: #909399;
        margin-bottom: 2px;
    }
    .content-text {
        font-size: 12px;
        color: #303133;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .content-urgent {
        color: #f56c6c !important;
        font-weight: 700;
    }
    .el-table td.el-table__cell .inventory-wrap {
        height: 80px;
        overflow: auto;
    }
    .el-table td.el-table__cell .inventory-table {
        width: 100%;
        table-layout: fixed;
    }
    .inventory-head,
    .inventory-total-row,
    .inventory-row {
        display: flex;
        width: 100%;
        justify-content: center;
    }
    .inventory-head span {
        flex: 0 0 100px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 11px;
        font-weight: 700;
        color: #909399;
        background: #f5f7fa;
    }
    .inventory-total-row span,
    .inventory-row span {
        flex: 0 0 100px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 11px;
    }
    .inventory-total-row span {
        font-weight: 700;
        color: #303133;
        border-bottom: 1px solid #ebeef5;
    }
    .inventory-row {
        color: #606266;
        border-bottom: 1px solid #ebeef5;
    }
    .inventory-row:last-child {
        border-bottom: none;
    }
    .inventory-row span {
        word-break: break-all;
        white-space: normal;
    }
</style>
